import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { ArrowIcon, Button as Button95, Checkbox, Hourglass, NumberInput, Panel, TextInput } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import { CustomText } from '@/components/CustomText';
import Footer from '@/components/Footer';
import { CustomDivider } from "@/components/CustomDivider";
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import * as AppConsts from "@/utilities/AppConsts";
import { useForm, Controller, Resolver } from "react-hook-form";
import { AppContext } from '@/components/AppContext';
import { CommunityMembership } from "@/types/community_membership";
import { RelativePathString, useLocalSearchParams, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setData } from '@/state/user';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  formElement: {
    width: AppConsts.BASIC_MINIMUM_WIDTH,
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
  panel: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  numericWrapper: {
    flexDirection: 'row',
    gap: 5,
  },
  numeric: {
    width: 80,
  },
  alignLeft: {
    alignSelf: 'flex-start',
  },
  checkboxWithIcon: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
});

export default function Preferences() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  //const [showAlertDialog, setShowAlertDialog] = useState(false);
  //const handleClose = () => setShowAlertDialog(false);
  const dispatch = useDispatch();
  const user_info = useSelector((state: RootState) => state.user.user_info);
  const { edit } = useLocalSearchParams<{ edit?: string }>();

  const [pref_allow_unmatched_messages, setpref_allow_unmatched_messages] = useState(user_info.pref_allow_unmatched_messages ?? true);
  const [pref_notify_daily_email, setpref_notify_daily_email] = useState(user_info.pref_notify_daily_email ?? false);
  const [pref_notify_weekly_email, setpref_notify_weekly_email] = useState(user_info.pref_notify_weekly_email ?? true);
  // ---------------------
  // ^^ Don't forget to add new items to the dependencies of onSubmit
  // ---------------------

  const onSubmit = useCallback(async() => {
    try {
      showSpinner();

      const response = await AppUtilities.fetchAuthorized(
        "Preferences.onSubmit",
        "/rabbl/api/set_preferences",
        "POST",
        {
          domain: domain,
          pref_allow_unmatched_messages: pref_allow_unmatched_messages,
          pref_notify_daily_email: pref_notify_daily_email,
          pref_notify_weekly_email: pref_notify_weekly_email,
        }
      );
      const membership: CommunityMembership = ((response as any).body as any).community_membership;
      dispatch(setData(response));

      if (edit && edit.length > 0 && router.canGoBack()) {
        router.back();
      } else {
        router.navigate(AppUtils.getProfileCreateNextPageLink(membership) as RelativePathString);
      }

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "Preferences.onSubmit");
    } finally {
      hideSpinner();
    }
  },
  [
    domain,
    pref_allow_unmatched_messages,
    pref_notify_daily_email,
    pref_notify_weekly_email,
  ]);

  return (
    <BasicScrollView center={true}>
      <Meta title={"Preferences"} />
            
      <Panel variant='raised' elevation={4}>
        <View style={styles.panel}>

          {/*<CustomText>Preferences</CustomText>

          <CustomDivider fullWidth={true} />*/}

          <View style={styles.alignLeft}>
            <CustomText>Messages</CustomText>
          </View>

          <Checkbox
            status={pref_allow_unmatched_messages ? 'checked' : 'unchecked'}
            onPress={() => setpref_allow_unmatched_messages(pref_allow_unmatched_messages ? false : true)}
            label="Allow people to message you before you've liked each other"
          />

          {/*<View style={styles.checkboxWithIcon}>
            <Checkbox
              status={pref_allow_unmatched_messages ? 'checked' : 'unchecked'}
              onPress={() => setpref_allow_unmatched_messages(pref_allow_unmatched_messages ? false : true)}
              label="Allow others to message you before you've liked each other"
            />
            <Pressable
              onPress={() => {setShowAlertDialog(true)}}
            >
              <FontAwesome
                name="info-circle"
                size={25}
                color={'#363636'}
                style={{ marginRight: 15 }}
              />
            </Pressable>
          </View>*/}

          <CustomDivider fullWidth={true} />
          
          <View style={styles.alignLeft}>
            <CustomText>Notifications</CustomText>
          </View>

          {/*
          <Checkbox
            status={pref_notify_daily_email ? 'checked' : 'unchecked'}
            onPress={() => setpref_notify_daily_email(pref_notify_daily_email ? false : true)}
            label="Send daily emails with some profiles you haven't decided on yet"
          />
          */}

          <Checkbox
            status={pref_notify_weekly_email ? 'checked' : 'unchecked'}
            onPress={() => setpref_notify_weekly_email(pref_notify_weekly_email ? false : true)}
            label="Send weekly emails with some profiles you haven't decided on yet"
          />

          <AppText>We'll send you a welcome email so double check it didn't go into spam/junk/promotions.</AppText>
          {/*<AppText>Double check your spam/junk/promotions folders.</AppText>*/}

          <View style={styles.buttonWrapper}>
            <Button95 onPress={onSubmit}>{ edit ? "Save" : "Next" }</Button95>
          </View>
        </View>
      </Panel>
      
      <Footer />

    </BasicScrollView>
  );
}
